const LAST_ROLE_KEY = "afrimed:last_role";
const LAST_ROLE_USER_KEY = "afrimed:last_role_user_id";

export function normalizeRole(value) {
  const role = String(value || "").toLowerCase().trim();
  return role === "doctor" ||
    role === "patient" ||
    role === "admin" ||
    role === "support" ||
    role === "kyc_reviewer" ||
    role === "moh" ||
    role === "super_admin" ||
    role === "moh_admin" ||
    role === "institution_admin" ||
    role === "facility_admin" ||
    role === "pharmacy"
    ? role
    : "";
}

export function readLastRole(userId = "") {
  try {
    const role = normalizeRole(localStorage.getItem(LAST_ROLE_KEY));
    if (!role) return "";

    const uid = String(userId || "").trim();
    if (!uid) return "";

    const owner = String(localStorage.getItem(LAST_ROLE_USER_KEY) || "").trim();

    if (!owner) return "";
    return owner === uid ? role : "";
  } catch {
    return "";
  }
}

export function writeLastRole(role, userId = "") {
  const nextRole = normalizeRole(role);
  if (!nextRole) return;
  const uid = String(userId || "").trim();
  if (!uid) return;

  try {
    localStorage.setItem(LAST_ROLE_KEY, nextRole);
    localStorage.setItem(LAST_ROLE_USER_KEY, uid);
  } catch {
    // ignore storage failures
  }
}

export function clearLastRole(userId = "") {
  const uid = String(userId || "").trim();
  try {
    const owner = String(localStorage.getItem(LAST_ROLE_USER_KEY) || "").trim();
    if (uid && owner && owner !== uid) return;
    localStorage.removeItem(LAST_ROLE_KEY);
    localStorage.removeItem(LAST_ROLE_USER_KEY);
  } catch {
    // ignore storage failures
  }
}
